document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'serviceCenterFinder', () => ({

		selectedState : '',
		centersByState: {},
		stateNames    : {},

		init( json ) {
			try {
				this.centersByState = JSON.parse( json );
			} catch {
				this.centersByState = {};
			}

			this.$el.querySelectorAll( 'option[value]' ).forEach( ( option ) => {
				if ( option.value ) {
					this.stateNames[ option.value ] = option.textContent;
				}
			});
		},

		get currentState() {
			return ! ! this.selectedState;
		},

		get currentStateName() {
			return this.stateNames[ this.selectedState ] || '';
		},

		get currentCenters() {
			return this.centersByState[ this.selectedState ] || [];
		},
	}) );
});
